import React from 'react'

const React_Coding_Practice_16 = () => {
  return (
    <div>
      <h1>Coding Pratice 16</h1>
    </div>
  )
}

export default React_Coding_Practice_16
